import {
  EnabledSubscriptionResponse,
  isCancelled,
  RawContractedSubscription
} from '@/models/api/subscription/contracted-subscription'
import {
  CancelledContractedSubscription,
  ContractedSubscription, EnabledContractedSubscription
} from '@/models/order/subscription/contracted/contracted-subscription'
import {
  ContractedSubscriptionFindRepository,
  ContractedSubscriptionListRepository
} from '@/models/order/subscription/contracted/contracted-subscription-repository'
import { getPaymentLabel } from '@/models/purhase/payment-type'
import { ApiClientWithAuth } from '@/services/api/client'

export class DefaultContractedSubscriptionRepository implements
  ContractedSubscriptionListRepository, ContractedSubscriptionFindRepository {
  constructor(private readonly apiClient: typeof ApiClientWithAuth) {
  }

  /*
   * 初期実装時点では単なるマッピングしかしていないので、 service モジュールを経由せず直接実装.
   *
   * apiの提供するリソース表現とclient側の持つモデルを分離する必要がでてきたら、
   * service モジュール および リソース表現用のオブジェクトを別途定義して中継させるようにしても良い.
   */
  async list(): Promise<ContractedSubscription[]> {
    const result = await this.apiClient.get('/api/user/subscription/contracted')
    const data: RawContractedSubscription[] = result.body.data

    return data.map(convertRawToModel)
  }

  async findById(id: string): Promise<ContractedSubscription> {
    const result = await this.apiClient.get(`/api/user/subscription/contracted/${id}`)
    const data: RawContractedSubscription = result.body.data

    return convertRawToModel(data)
  }
}

const convertRawToModel = (d: RawContractedSubscription): ContractedSubscription => {
  const base = {
    id: d.id,
    displayId: d.short_id,
    contractedAt: new Date(d.contracted_at),
    delivery: {
      customerName: d.delivery.customer.name,
      postalCode: d.delivery.address.postal_code,
      region: d.delivery.address.region,
      city: d.delivery.address.city,
      addressLine: d.delivery.address.address_line,
      telNumber: d.delivery.tel,
      method: d.delivery.method,
    },
    payment: {
      totalPrice: d.payment.total_price,
      deliveryFee: d.payment.delivery_fee,
      commission: d.payment.commission,
      method: getPaymentLabel(d.payment.method),
      method_detail: d.payment.method.detail,
    },
    frequency: d.frequency,
    cancel: {
      isEnable: d.cancel.enable,
    },
  }

  const cancelled: () => CancelledContractedSubscription = () => ({
    ...base,
    schedule: {
      next: null,
    },
    isEnabled() {
      return false
    },
  })
  const enabled: (r: EnabledSubscriptionResponse) => EnabledContractedSubscription = r => ({
    ...base,
    schedule: {
      next: new Date(r.schedule.next),
    },
    isEnabled() {
      return true
    },
  })

  return isCancelled(d) ? cancelled() : enabled(d)
}
